import {useAutocomplete} from "@/app-autocomplete/providers/AutocompleteProvider.tsx";
import {useTranslations} from "@/hooks/useTranslations.ts";
import {useEffect} from "react";

export function Form() {
    const {
        inputRef,
        formRef,
        autocomplete,
        isModalOpen,
        autocompleteState: {query},
    } = useAutocomplete();
    const tc = useTranslations();
    useEffect(() => {
        if (isModalOpen && inputRef?.current && document.activeElement !== inputRef.current) {
            inputRef.current.focus();
        }
    }, [isModalOpen]);
    return (
        <form ref={formRef} className="aa-form" {...autocomplete.getFormProps({inputElement: inputRef.current})}>
            <div className="aa-form__searchBar">
                <label className={"aa-form__label"} {...autocomplete.getLabelProps({})}>
                    <button className="aa-form__submit" type={"submit"}>
                        <span className={"sr-only"}>{tc.search}</span>
                        <i className="icon icon-search" aria-hidden="true"></i>
                    </button>
                </label>
                <input
                    ref={inputRef}
                    className="aa-form__input"
                    {...autocomplete.getInputProps({
                        inputElement: inputRef.current,
                    })}
                />
                {query && (
                    <button className="aa-form__clear" title="Clear" type="reset">
                        <i className="icon icon-close" aria-hidden={true}></i>
                    </button>
                )}
            </div>
            <small className={"aa-form__legend"}>{tc.searchHint}</small>
        </form>
    );
}
